import { Popper } from '@material-ui/core';
import clsx from 'clsx';
import React, { useRef } from 'react';

import ClickAwayListener from '@/src/components/common/ClickAwayListener/ClickAwayListener';
import { TextContainingFilterOption } from '@/src/components/common/FilterBox/V2/FilterBox';
import { TextContainingFilteBox } from '@/src/components/common/FilterBox/V2/TextContainingFilteBox';
import { useMyPortfolio } from '@/src/components/myTasks2/components/Tabs/MyPortfolio/store/myPortfolio.store';
import { useToggle } from '@/src/hooks/useToggle';
import { SortOrder } from '@/src/util/filters';

import { getSortIndicator } from './HeaderItem';

import FilterCount from '../../../../../Elements/FilterCount/FilterCount';
import { ColumnOption } from '../../Table/Table';

type TextContainingHeaderItemProps = {
  column: ColumnOption;
  filterOption: TextContainingFilterOption;
};

const TextContainingHeaderItem = ({ column, filterOption }: TextContainingHeaderItemProps) => {
  const { updateFilterOptions, sorting } = useMyPortfolio();
  const filterRef = useRef();
  const [showFilter, toggleShowFilter] = useToggle(false);
  const filterKey = column.column.name;
  const isColumnSorted = sorting.column === column.column.name;
  const sortIndicator = getSortIndicator({
    column,
    isColumnSorted,
    isDesc: sorting?.order === SortOrder.DESC,
  });

  const withValueFilters = filterOption.isActive;
  const withValueFiltersChangesCount = Number(withValueFilters);
  const withValueFiltersWithChanges = withValueFiltersChangesCount > 0;

  const handleUpdateFilters = (filterOption: TextContainingFilterOption) => {
    updateFilterOptions({
      columnKey: column.column.name,
      filterOption,
    });
  };

  const handleUpdateSorting = () => {
    //
  };

  const handleReset = () => {
    updateFilterOptions({
      columnKey: column.column.name,
      filterOption: {
        ...filterOption,
        value: '',
        isActive: false,
      },
    });
  };

  return (
    <React.Fragment>
      <a
        onClick={toggleShowFilter}
        className={clsx(
          'filterTrigger',
          isColumnSorted && 'hasSorting',
          (withValueFiltersWithChanges || showFilter) && 'active'
        )}
        ref={filterRef}
      >
        {sortIndicator}
        <span>{column.title}</span>
        <div className={`filterIcon ${withValueFiltersWithChanges ? 'active' : ''}`}>
          <i className="material-icons">filter_list</i>
          {withValueFiltersWithChanges && (
            <FilterCount onReset={handleReset} count={withValueFiltersChangesCount} />
          )}
        </div>
      </a>

      <Popper
        id={filterKey}
        open={showFilter}
        anchorEl={filterRef.current}
        placement="bottom-start"
        style={{ zIndex: 100 }}
      >
        <ClickAwayListener onClickAway={() => toggleShowFilter(false)}>
          <TextContainingFilteBox
            classes={{ options: '' }}
            column={column}
            sortingType={column.sorting}
            sortingSelected={sorting}
            filterOption={filterOption}
            onUpdateFilters={handleUpdateFilters}
            onUpdateSorting={handleUpdateSorting}
            isAsc={isColumnSorted && sorting?.order === SortOrder.ASC}
            isDesc={isColumnSorted && sorting?.order === SortOrder.DESC}
          />
        </ClickAwayListener>
      </Popper>
    </React.Fragment>
  );
};

export default TextContainingHeaderItem;
